<template>
  <layout-bottom-sheet ref="bottomSheet" bottomSheetClass="reset-email-sent">
    <template v-slot:header>
      <div class="title" @click="close">
        {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.checkYourEmail') }}
      </div>
    </template>

    <div class="description">
      <div>{{ getContent(popupsData, defaultLocalePopupsData, 'authorization.linkToReset') }}</div>

      <span class="bold">{{ email }}</span>
    </div>

    <template v-slot:footer>
      <button-base type="primary" size="md" @click="close">
        {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.gotIt') }}
      </button-base>
    </template>
  </layout-bottom-sheet>
</template>

<script setup lang="ts">
  import type { IBottomSheetComponent } from '@skeleton/core/types';

  defineProps<{
    email: string;
  }>();

  const { getContent } = useProjectMethods();

  const {
    popupsData,
    defaultLocalePopupsData,
  } = storeToRefs(useGlobalStore());

  const bottomSheet = ref<Maybe<IBottomSheetComponent>>();

  const close = (): void => {
    bottomSheet.value!.close();
  };

  const open = async (): void => {
    await bottomSheet.value!.open();
  };

  defineExpose({
    open,
    close,
  });
</script>

<style src="~/assets/styles/components/bottom-sheet/reset-email-send.scss" lang="scss" />
